import React from 'react'

// A little hacky, but somehow I had trouble with <Redirect> from OldApp to a new App route (maybe because they're separate non-nested Routers?)
// https://stackoverflow.com/a/58089453/992015
class AbsoluteRedirect extends React.Component {
    componentDidMount(){
        window.location = this.props.to
    }
    render(){
        return null
    }
}

export default AbsoluteRedirect
